import { ANGEL_COOKIE_DOMAIN, ANGEL_PREVIEW_COOKIE_DOMAIN } from '@/constants/cookies'
import { paths } from '@/constants/paths'
import { isProductionEnvironment } from '@/utils/environment-utils'

/**
 * Gets the legacy cookie domain for the current environment.
 * Production: .angel.com
 * Preview: .angel-preview.com
 * Other (staging, localhost): undefined
 *
 * Use this to clear legacy domain cookies during the transition to host-only cookies.
 */
export function getLegacyCookieDomain(): string | undefined {
  if (isProductionEnvironment()) {
    return ANGEL_COOKIE_DOMAIN
  }

  try {
    const baseUrl = paths.getBaseURL()
    const url = new URL(baseUrl)
    if (url.hostname === 'angel-preview.com' || url.hostname.endsWith('.angel-preview.com')) {
      return ANGEL_PREVIEW_COOKIE_DOMAIN
    }
  } catch {
    // If URL parsing fails, fall back to undefined
  }

  return undefined
}
